"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLayoutOfThreeView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const StyledGrid = (0, app_1.styled)(ui_1.Grid) `
  position: relative;
  @media ${app_1.notDesktop} {
    grid-template-columns: minmax(0, 1fr);
  }
`;
const StyledGridItem = (0, app_1.styled)(ui_1.GridItem) `
  position: relative;
  @media ${app_1.notDesktop} {
    grid-row: unset;
    grid-column: unset;
  }
  :after {
    content: '';
    display: block;
    padding-top: 75%;
  }
`;
const layoutDef = {
    left: [{ rowSpan: '2', colSpan: '2' }, {}, {}],
    right: [{}, { rowSpan: '2', colSpan: '2' }, {}],
};
function GridLayoutOfThreeViewLoader({ layout, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Array.from({ length: 3 }).map((_v, index) => ((0, jsx_runtime_1.jsx)(StyledGridItem, Object.assign({}, layoutDef[layout][index], { children: (0, jsx_runtime_1.jsx)(ui_1.SkeletonBox, {}) }), index))) }));
}
function GridLayoutOfThreeView({ data, render, layout, className, }) {
    return ((0, jsx_runtime_1.jsx)(StyledGrid, Object.assign({ templateColumns: "repeat(3, minmax(0, 1fr))", templateRows: "repeat(2, minmax(0, 1fr))", className: className, gap: "0.1875rem" }, { children: data ? (data.map((d, i) => ((0, jsx_runtime_1.jsx)(StyledGridItem, Object.assign({}, layoutDef[layout][i], { children: render(d) }), d.id)))) : ((0, jsx_runtime_1.jsx)(GridLayoutOfThreeViewLoader, { layout: layout })) })));
}
exports.GridLayoutOfThreeView = GridLayoutOfThreeView;
